import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import {Section} from "../../02-Molecules/Section/Section"
import PropTypes from "prop-types"

/**
 * SectionApplePayButton component.
 */
export const SectionBackToLandingPage = forwardRef(({ collapsed, ctaText, heading, headingLarge,
  location, sectionId, textAfter, textBefore,  ...props }, ref) => {
  return (
    <Section collapsed={collapsed} heading={heading} headingLarge={headingLarge} sectionId={sectionId} textAfter={textAfter} textBefore={textBefore}>
      <a href={location}>{ctaText}</a>
    </Section>
  )
})

/**
 * SectionBackToLandingPage PropType
 */
SectionBackToLandingPage.propTypes = {
  collapsed : PropTypes.bool,
  ctaText   : PropTypes.string,
  heading   : PropTypes.string,
  headingLarge  : PropTypes.bool,
  location  : PropTypes.string,
  sectionId : PropTypes.string,
  textAfter : PropTypes.string,
  textBefore: PropTypes.string
}


